export default [
  'abnormally',
  'absentmindedly',
  'accidentally',
  'acidly',
  'actually',
  'adventurously',
  'afterwards',
  'almost',
  'always',
  'angrily',
  'annually',
  'anxiously',
  'arrogantly',
  'awkwardly',
  'badly',
  'bashfully',
  'beautifully',
  'bitterly',
  'bleakly',
  'blindly',
  'blissfully',
  'boastfully',
  'boldly',
  'bravely',
  'briefly',
  'brightly',
  'briskly',
  'broadly',
  'busily',
  'calmly',
  'carefully',
  'carelessly',
  'cautiously',
  'certainly',
  'cheerfully',
  'clearly',
  'cleverly',
  'closely',
  'coaxingly',
  'colorfully',
  'commonly',
  'continually',
  'coolly',
  'correctly',
  'courageously',
  'crossly',
  'cruelly',
  'curiously',
  'daily',
  'daintily',
  'dearly',
  'deceivingly',
  'deeply',
  'defiantly',
  'deliberately',
  'delightfully',
  'diligently',
  'dimly',
  'doubtfully',
  'dreamily',
  'easily',
  'elegantly',
  'energetically',
  'enormously',
  'enthusiastically',
  'equally',
  'especially',
  'even',
  'evenly',
  'eventually',
  'exactly',
  'excitedly',
  'extremely',
  'fairly',
  'faithfully',
  'famously',
  'far',
  'fast',
  'fatally',
  'ferociously',
  'fervently',
  'fiercely',
  'fondly',
  'foolishly',
  'fortunately',
  'frankly',
  'frantically',
  'freely',
  'frenetically',
  'frightfully',
  'fully',
  'furiously',
  'generally',
  'generously',
  'gently',
  'gladly',
  'gleefully',
  'gracefully',
  'gratefully',
  'greatly',
  'greedily',
  'happily',
  'hastily',
  'healthily',
  'heavily',
  'helpfully',
  'helplessly',
  'highly',
  'honestly',
  'hopelessly',
  'hourly',
  'hungrily',
  'immediately',
  'innocently',
  'inquisitively',
  'instantly',
  'intensely',
  'intently',
  'interestingly',
  'inwardly',
  'irritably',
  'jaggedly',
  'jealously',
  'joshingly',
  'jovially',
  'joyfully',
  'joyously',
  'jubilantly',
  'judgementally',
  'justly',
  'keenly',
  'kiddingly',
  'kindheartedly',
  'kindly',
  'kissingly',
  'knavishly',
  'knottily',
  'knowingly',
  'knowledgeably',
  'kookily',
  'lazily',
  'less',
  'lightly',
  'likely',
  'limply',
  'lively',
  'loftily',
  'longingly',
  'loosely',
  'loudly',
  'lovingly',
  'loyally',
  'madly',
  'majestically',
  'meaningfully',
  'mechanically',
  'merrily',
  'miserably',
  'mockingly',
  'monthly',
  'more',
  'mortally',
  'mostly',
  'mysteriously',
  'naturally',
  'nearly',
  'neatly',
  'needily',
  'nervously',
  'never',
  'nicely',
  'noisily',
  'not',
  'obediently',
  'obnoxiously',
  'oddly',
  'offensively',
  'officially',
  'often',
  'only',
  'openly',
  'optimistically',
  'overconfidently',
  'owlishly',
  'painfully',
  'partially',
  'patiently',
  'perfectly',
  'physically',
  'playfully',
  'politely',
  'poorly',
  'positively',
  'potentially',
  'powerfully',
  'promptly',
  'properly',
  'punctually',
  'quaintly',
  'quarrelsomely',
  'queasily',
  'queerly',
  'questionably',
  'questioningly',
  'quicker',
  'quickly',
  'quietly',
  'quirkily',
  'quizzically',
  'rapidly',
  'rarely',
  'readily',
  'really',
  'reassuringly',
  'recklessly',
  'regularly',
  'reluctantly',
  'repeatedly',
  'reproachfully',
  'restfully',
  'righteously',
  'rightfully',
  'rigidly',
  'roughly',
  'rudely',
  'sadly',
  'safely',
  'scarcely',
  'scarily',
  'searchingly',
  'sedately',
  'seemingly',
  'seldom',
  'selfishly',
  'separately',
  'seriously',
  'shakily',
  'sharply',
  'sheepishly',
  'shrilly',
  'shyly',
  'silently',
  'sleepily',
  'slowly',
  'smoothly',
  'softly',
  'solemnly',
  'solidly',
  'sometimes',
  'soon',
  'speedily',
  'stealthily',
  'sternly',
  'strictly',
  'successfully',
  'suddenly',
  'surprisingly',
  'suspiciously',
  'sweetly',
  'swiftly',
  'sympathetically',
  'tenderly',
  'tensely',
  'terribly',
  'thankfully',
  'thoroughly',
  'thoughtfully',
  'tightly',
  'tomorrow',
  'too',
  'tremendously',
  'triumphantly',
  'truly',
  'truthfully',
  'ultimately',
  'unabashedly',
  'unaccountably',
  'unbearably',
  'unethically',
  'unexpectedly',
  'unfortunately',
  'unimpressively',
  'unnaturally',
  'unnecessarily',
  'upbeat',
  'upliftingly',
  'upright',
  'upside-down',
  'upward',
  'upwardly',
  'urgently',
  'usefully',
  'uselessly',
  'usually',
  'utterly',
  'vacantly',
  'vaguely',
  'vainly',
  'valiantly',
  'vastly',
  'verbally',
  'very',
  'viciously',
  'victoriously',
  'violently',
  'vivaciously',
  'voluntarily',
  'warmly',
  'weakly',
  'wearily',
  'well',
  'wetly',
  'wholly',
  'wildly',
  'willfully',
  'wisely',
  'woefully',
  'wonderfully',
  'worriedly',
  'wrongly',
  'yawningly',
  'yearly',
  'yearningly',
  'yesterday',
  'yieldingly',
  'youthfully',
]
